// ============================================================
// Глобальная регистрация компонентов дизайн-системы
// Импортируется один раз в main.js.
// Добавив новый компонент в components — он станет доступен
// во всех шаблонах без явного import.
// ============================================================
import Vue from 'vue'
import BaseModal from '@/components/design/BaseModal.vue'
import BaseBadge from '@/components/design/BaseBadge.vue'
import BaseCard from '@/components/design/BaseCard.vue'
import AppButton from '@/components/design/AppButton.vue'
import AppSelect from '@/components/design/AppSelect.vue'
import AppMultiSelect from '@/components/design/AppMultiSelect.vue'
import CFInput from '@/components/design/CFInput.vue'
import AppTable from '@/components/design/AppTable.vue'
import StatCard from '@/components/design/StatCard.vue'
import StatGrid from '@/components/design/StatGrid.vue'
import MediaGallery from '@/components/design/MediaGallery.vue'
import SelectOrAdd from '@/components/design/SelectOrAdd.vue'
import SearchSelect from '@/components/design/SearchSelect.vue'
import HoverTip from '@/components/design/HoverTip.vue'
import DateTimeField from '@/components/design/DateTimeField.vue'
import PlanningDay from '@/components/planning/PlanningDay.vue'
import PickerModal from '@/components/planning/PickerModal.vue'
import DriverPickerModal from '@/components/planning/DriverPickerModal.vue'
import BatchPickerModal from '@/components/planning/BatchPickerModal.vue'
import MapPointPicker from '@/components/planning/MapPointPicker.vue'

const components = {
  BaseModal,
  BaseBadge,
  BaseCard,
  AppButton,
  AppSelect,
  AppMultiSelect,
  CFInput,
  AppTable,
  StatCard,
  StatGrid,
  MediaGallery,
  SelectOrAdd,
  SearchSelect,
  HoverTip,
  DateTimeField,
  PlanningDay,
  PickerModal,
  DriverPickerModal,
  BatchPickerModal,
  MapPointPicker
}

export default {
  install() {
    Object.entries(components).forEach(([name, comp]) => {
      Vue.component(name, comp)
    })
  }
}
